import { StrictLocalizeFunction } from "../localization/localize";

export const CANADA_PROVINCE_SHORTHAND_TO_NAME = (
  strictLocalize: StrictLocalizeFunction
) =>
  ({
    AB: strictLocalize({
      id: "f02w5O",
      defaultMessage: "Alberta",
      description: { text: "Canadian province" },
    }),
    BC: strictLocalize({
      id: "gUWdPo",
      defaultMessage: "British Columbia",
      description: { text: "Canadian province" },
    }),
    MB: strictLocalize({
      id: "2pEi2z",
      defaultMessage: "Manitoba",
      description: { text: "Canadian province" },
    }),
    NB: strictLocalize({
      id: "DwU9uH",
      defaultMessage: "New Brunswick",
      description: { text: "Canadian province" },
    }),
    NL: strictLocalize({
      id: "T9jrUj",
      defaultMessage: "Newfoundland",
      description: { text: "Canadian province" },
    }),
    NS: strictLocalize({
      id: "7P0KEE",
      defaultMessage: "Nova Scotia",
      description: { text: "Canadian province" },
    }),
    NT: strictLocalize({
      id: "xA/xmt",
      defaultMessage: "Northwest Territories",
      description: { text: "Canadian territory" },
    }),
    NU: strictLocalize({
      id: "egmAMj",
      defaultMessage: "Nunavut",
      description: { text: "Canadian territory" },
    }),
    ON: strictLocalize({
      id: "JMFOPl",
      defaultMessage: "Ontario",
      description: { text: "Canadian province" },
    }),
    PE: strictLocalize({
      id: "izzGFg",
      defaultMessage: "Prince Edward Island",
      description: { text: "Canadian province" },
    }),
    QC: strictLocalize({
      id: "o1Sa0I",
      defaultMessage: "Quebec",
      description: { text: "Canadian province" },
    }),
    SK: strictLocalize({
      id: "zimP52",
      defaultMessage: "Saskatchewan",
      description: { text: "Canadian province" },
    }),
    YT: strictLocalize({
      id: "PHsfo9",
      defaultMessage: "Yukon",
      description: { text: "Canadian territory" },
    }),
  }) as const;
